<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8 12V15.4286"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.28516 15.4282H13.7137"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99944 11.9999C11.1554 11.9999 13.7137 9.44148 13.7137 6.28558C13.7137 3.12967 11.1554 0.571289 7.99944 0.571289C4.84353 0.571289 2.28516 3.12967 2.28516 6.28558C2.28516 9.44148 4.84353 11.9999 7.99944 11.9999Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.28516 6.28564H13.7137"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.9989 11.9999C11.4275 8.09129 11.4275 4.27415 7.9989 0.571289C4.6389 4.137 4.57033 7.93129 7.9989 11.9999Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
